import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';

const roreRotationTypes = [
  {
    path: 'rotationtypes',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.trc('rore', 'Rotation Types')
      },
      permissions: ['READ_RORE_ROTATION_TYPES']
    },
    children: [
      {
        path: '',
        name: 'roreRotationTypesList',
        component: wrapLegacyRoute('roreRotationTypesController', 'list')
      },
      {
        path: 'create',
        name: 'roreRotationTypeCreate',
        component: wrapLegacyRoute('roreRotationTypesController', 'create')
      },
      {
        path: ':rotationTypeId(\\d+)',
        name: 'roreRotationTypeDetails',
        component: wrapLegacyRoute('roreRotationTypesController', 'details')
      }
    ]
  }
];

export default roreRotationTypes;
